// Product identity for the shared @juristai packages; must run before any app module.
import "./polyfills";
import "./productConfig";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./state/store";
import { HelmetProvider } from "react-helmet-async";
import { initializeSentry } from "./lib/sentry";
import { applySeasonalTheme } from "./lib/seasonalTheme";
import ErrorBoundary from "./components/shared/ErrorBoundary/ErrorBoundary";

initializeSentry();
applySeasonalTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <ErrorBoundary boundaryName="JuristAIHomeRoot">
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
